export default __webpack_public_path__ + "static/media/flourishing_cyan_petal.0dea1b24.svg";